export default __webpack_public_path__ + "static/media/fibois_logo.927f0296.png";